import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';

export const endAllSessions = async (userId: string): Promise<void> => {
  return await tinctApi.users.endAllSessions(userId);
};

/**
 * Signs the user (the mutation's variable: their id) out of every device, this one included
 * (B-275): every token issued so far stops working at once. The caller sends the browser through
 * `/logout` afterwards.
 */
export const useEndAllSessions = (
  options?: Omit<UseMutationOptions<void, ApiError, string>, 'mutationFn'>,
) => {
  return useMutation({
    mutationFn: endAllSessions,
    ...options,
  });
};
